import React from 'react';

const SvgPlus = props => (
    <svg width="1em" height="1em" viewBox="0 0 14 14" {...props}>
        <path d="M6 6V2h2v4h4v2H8v4H6V8H2V6h4z" fill="#000" fillRule="evenodd" />
    </svg>
);

export default SvgPlus;
